import CampList from '../../filter_desktop/camp_list.js.jsx';
import FilterMain from '../../filter_main.js.jsx';
import SmallMessage from '../../message/desktop/small_message.js.jsx';
import SearchDesktop from './search_desktop.js.jsx';

export default class FavoritesDesktop extends FilterMain {
  constructor(props) {
    super(props);
    this.showMoreCamps = this.showMoreCamps.bind(this);
    this.copyUrl = this.copyUrl.bind(this);
    this.isFavorites = true;
  }

  componentDidMount() {
    this.contentEl = document.querySelector('.content');
    if (this.contentEl) {
      this.prevOverflowX = this.contentEl.style.overflowX;
      this.contentEl.style.overflowX = 'visible';
    }
    super.componentDidMount();
    this.setMessageSettings();
  }

  componentWillUnmount() {
    if (this.contentEl) {
      this.contentEl.style.overflowX = this.prevOverflowX || '';
    }
  }

  showMoreCamps() {
    this.setState((prevState) => {
      const remainingCamps = prevState.filteredFavoriteCamps.length - prevState.visibleFavoriteCamps;
      return {
        visibleFavoriteCamps: prevState.visibleFavoriteCamps + Math.min(10, remainingCamps),
      };
    });
  }

  setMessageSettings() {
    this.setState({ isShowMessage: false });
  }

  copyUrl() {
    if (window.isSecureContext && navigator.clipboard) {
      const campIds = (this.props.camps || []).map((camp) => camp.id).join(',');
      const baseUrl = location.href.split('?')[0];
      const params = new URLSearchParams(this.props.filter_params?.url_str || '');
      if (campIds) params.set('camp_ids', campIds);
      const shareUrl = `${baseUrl}?${params.toString()}`;
      navigator.clipboard.writeText(shareUrl);
      this.setState({ isShowMessage: true });
      setTimeout(() => {
        this.setState({ isShowMessage: false });
      }, 5000);
    }
  }

  render() {
    const { visibleFavoriteCamps, filteredFavoriteCamps, activeRegion, isShowMessage } = this.state;

    let campList;
    const regionList = ['Все', ...this.props.regions.map((region) => region.name)];
    const message = 'Ссылка скопирована';
    const type = 'succes';

    if (this.props.camps?.length > 0) {
      campList = (
        <div>
          <CampList
            camps={filteredFavoriteCamps}
            showContractPercent={this.props.admin_data.show_contract_percent}
            showCommission={this.props.admin_data.show_commission}
            filter_params={this.props.filter_params}
            count_guests={this.state.s_params.count_guests}
            fewerCountGuests={this.fewerCountGuests}
            delta_days={this.props.delta_days}
            filters={this.state.filters}
            showAllCamps={true}
            visibleFavoriteCamps={visibleFavoriteCamps}
            campsLoaded={this.state.favoriteCampsLoaded}
            children_ages={this.state.s_params.children_ages}
            favorites={this.state.favorites}
            toggleFavoriteCamp={this.toggleFavoriteCamp}
          />

          {visibleFavoriteCamps < filteredFavoriteCamps.length && (
            <div className='more-container'>
              <button className='more-container__btn' onClick={this.showMoreCamps}>
                Показать еще
              </button>

              <div className='more-container__info'>
                Показаны {visibleFavoriteCamps} из {filteredFavoriteCamps.length}
              </div>
            </div>
          )}
        </div>
      );
    }
    return (
      <div className='container favorite-container'>
        <div className='menu-aside regions-aside'>
          {regionList.map((region, index) => (
            <div
              className={`menu-aside__item ${activeRegion === index ? 'menu-aside__item-active' : ''}`}
              onClick={() => this.handleRegionChange(index)}
            >
              <a>{region}</a>
            </div>
          ))}
        </div>

        <div style={{ width: '100%' }}>
          <div className='container favorite-header'>
            <h3>Избранное</h3>

            <div onClick={this.copyUrl} className='favorite-share'>
              <div className='favorite-share__icon'></div>
              <div className='favorite-share__text'>Поделиться</div>
            </div>
          </div>

          <SearchDesktop
            date_start={this.props.s_params.date_start}
            date_end={this.props.s_params.date_end}
            dates_range={this.props.s_params.dates_range_printable}
            adults_count={this.props.s_params.adults_count}
            children_count={this.props.s_params.children_count}
            with_pet={this.props.s_params.with_pet}
            count_guests={this.props.s_params.count_guests}
            children_ages={this.props.s_params.children_ages}
          />

          <div className='page-divider favorite_page-divider'></div>

          {campList}
        </div>
        {isShowMessage && <SmallMessage message={message} type={type} />}
      </div>
    );
  }
}
